import LLGlobeTrotter from '@/locales/GlobeTrotter/fr';
import LLTrendingNow from '@/locales/TrendingNow/fr';
import LLEdito from '@/locales/Edito/fr';
import LLTravel from '@/locales/Travel/fr';
import LLTune from '@/locales/Tune/fr';
import LLFuture from '@/locales/Future/fr';
import LLArty from '@/locales/Arty/fr';
import LLKeyReport from '@/locales/KeyReport/fr';
import LLEntrepreneurs from '@/locales/Entrepreneurs/fr';
import LLEssential from '@/locales/Essential/fr';
import LLLegal from '@/locales/Legal/fr';

export const  fr = {

    // les éléments du menu
    // pour l'edito, vu qu'il est variable en fonction du marché (present dans l'url), la structure est un peu différente
    menu: {
        EditoCH: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoLU: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoUK: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoFR: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoMC: {
            segment: 'edito',
            title: 'Édito',
        },
        Essential: {
            segment: 'les-essentiels',
            title: 'Les essentiels',
        },
        TrendingNow: {
            segment: 'tendances',
            title: 'Tendances',
        },
        GlobeTrotter: {
            segment: 'planete-insolite',
            title: 'Planète insolite',
        },
        Travel: {
            segment: 'explorer-silence-objectifs-cinq-photographes',
            title: 'Explorer le silence à travers l’objectif de cinq photographes',
        },
        Tune: {
            segment: 'nouvelle-partition-musique-classique',
            title: 'Une nouvelle partition pour la musique classique',
        },
        Future: {
            segment: 'hydrogene-nouvel-espoir-climat',
            title: 'L’hydrogène, un nouvel espoir pour le climat',
        },
        Arty: {
            segment: 'rencontre-emmanuel-perrotin',
            title: 'Rencontre avec Emmanuel Perrotin',
        },
        KeyReport: {
            segment: 'promesses-e-sante',
            title: 'Les promesses de la e-santé',
        },
        Entrepreneurs: {
            segment: 'philanthropie-participative-philippe-journo',
            title: 'La philanthropie participative selon Philippe Journo',
        },
        Legal: {
            segment: 'credits-informations-legales',
            title: 'Credits & informations légales',
        },

    },

    // les différentes pages, on scinde en fichiers, sinon ca va être trop long et chiant a contribuer

    Essential: LLEssential,

    EditoCH: LLEdito,
    EditoLU: LLEdito,
    EditoUK: LLEdito,
    EditoFR: LLEdito,
    EditoMC: LLEdito,

    TrendingNow: LLTrendingNow,

    GlobeTrotter: LLGlobeTrotter,

    Travel: LLTravel,
    Tune: LLTune,

    Future: LLFuture,

    Arty: LLArty,

    KeyReport: LLKeyReport,

    Entrepreneurs: LLEntrepreneurs,

    Legal: LLLegal,

    home: {
        logoBaseLine: 'Voir le monde différemment&nbsp;avec <br />Société&nbsp;Générale Private&nbsp;Banking <br/>Automne 2020 #5',
        title: 'La philanthropie participative selon Philippe Journo',
        artitle1title: 'Elles pensent le futur',
        artitle1content: 'L’hydrogène, un nouvel espoir pour le climat',
        artitle2title: 'Le grand dossier',
        artitle2content:  'Les promesses de la e-santé',
        artitle3title: 'Voyager différemment',
        artitle3content:  'Explorer le silence à travers l’objectif de cinq photographes',
    },

    next: 'À suivre : ',

    welcome_message : 'FR - Welcome to Your Vue.js App',
    popular_links : 'FR - Popular Links',
    ecosystem : 'FR - Ecosystem',
    test: {
        toto: 'toto label',
        tutu: 'tutu label',
        titi: {
            test: 'titi label',
        },
    },
    counterUpSeparator: '&nbsp;',
    counterUpDecimal: ',',
};
